import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import { Tracker } from '../Tracker';
import { PAGEVIEW_EVENT_NAME, SAFER_GAMBLING_EVENT_NAME } from './constants';

export var SaferGamblingMenuTracker = function (_Tracker) {
  _inherits(SaferGamblingMenuTracker, _Tracker);

  function SaferGamblingMenuTracker() {
    _classCallCheck(this, SaferGamblingMenuTracker);

    return _possibleConstructorReturn(this, (SaferGamblingMenuTracker.__proto__ || _Object$getPrototypeOf(SaferGamblingMenuTracker)).apply(this, arguments));
  }

  _createClass(SaferGamblingMenuTracker, [{
    key: 'gamblingMenuLanded',
    value: function gamblingMenuLanded() {
      this.publishPartialEvent(PAGEVIEW_EVENT_NAME, {
        SiteSubSection: 'Safer Gambling',
        SiteSection: 'Account'
      });
    }
  }, {
    key: 'gamblingClicked',
    value: function gamblingClicked() {
      this.publishPartialEvent(SAFER_GAMBLING_EVENT_NAME, {
        SiteSectionCategory: 'Safer Gambling Link',
        EventAction: 'Category Selection',
        EventLabel: 'Safer Gambling Link',
        ElementType: 'Spitfire'
      });
    }
  }, {
    key: 'panelClosed',
    value: function panelClosed() {
      this.publishPartialEvent(SAFER_GAMBLING_EVENT_NAME, {
        SiteSectionCategory: 'Notification Close',
        EventAction: 'Category Selection',
        EventLabel: 'Notification Close',
        ElementType: 'Spitfire'
      });
    }
  }]);

  return SaferGamblingMenuTracker;
}(Tracker);